import { logger } from "../../../utilities/logger";
import { customToast } from "../components/CustomToast";
import { IEmailAttachment } from "../interfaces/services/IEmailAttachment";

export class InlineMailHelper {
  static setItemLinks(items: IEmailAttachment[], errorMessage: string) {
    const outlookItem = Office.context.mailbox.item;
    let links = "";

    items.forEach((item) => {
      links = `${links} <a href="${item.url}">${item.name}</a><br/>`;
    });

    try {
        outlookItem.body.getTypeAsync({ asyncContext: null }, (result) => {
          if (result.status == Office.AsyncResultStatus.Failed) {
            customToast.error(errorMessage);
          } else {
            outlookItem.body.setSelectedDataAsync(
              links,
              { coercionType: Office.CoercionType.Html, asyncContext: { var3: 1, var4: 2 } },
              (asyncResult) => {
                if (asyncResult.status == Office.AsyncResultStatus.Failed) {
                  customToast.error(errorMessage);
                }
              }
            );
          }
        });
    } catch (error) {
      logger(error, "ContentBodyFilesFolders.tsx (setItemLinks)");
    }
  }

  static setAttachments = (items: IEmailAttachment[], errorMessage: string) => {
    items.map((item) => {
      Office.context.mailbox.item.addFileAttachmentAsync(item.url, item.name, { isInline: false }, (asyncResult) => {
        if (asyncResult.status == Office.AsyncResultStatus.Failed) {
          customToast.error(errorMessage);
        }
      });
    });
  };
}
